export default "__VITE_ASSET__DP5tB64F__"